import React, { useEffect } from 'react';
import { AiOutlineMenu } from 'react-icons/ai';
import { MdKeyboardArrowDown, MdOutlinePassword, MdLogout } from 'react-icons/md';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';

import { RxAvatar } from "react-icons/rx";
import { UserProfile, CambioPassword } from '.';
import { useStateContext } from '../contexts/ContextProvider';
import { fetchUser } from '../utils/fetchUser';
import AuthServices from '../actions/actions';
import { useNavigate } from 'react-router-dom';

const NavButton = ({ title, customFunc, icon, color, dotColor }) => (
  <TooltipComponent content={title} position="BottomCenter">
    <button
      type="button"
      onClick={() => customFunc()}
      style={{ color }}
      className="relative text-xl rounded-full p-3 hover:bg-light-gray"
    >
      <span
        style={{ background: dotColor }}
        className="absolute inline-flex rounded-full h-2 w-2 right-2 top-2"
      />
      {icon}
    </button>
  </TooltipComponent>
);

const Navbar = () => {
  const { currentColor, activeMenu, setActiveMenu, handleClick, isClicked, setScreenSize, screenSize } = useStateContext();

  const userInfo = fetchUser();
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (screenSize <= 900) {
      setActiveMenu(false);
    } else {
      setActiveMenu(true);
    }
  }, [screenSize]);

  const handleActiveMenu = () => setActiveMenu(!activeMenu);

  return (
    <div className="flex justify-between p-2 md:ml-6 md:mr-6 relative">

      <NavButton title="Menu" customFunc={handleActiveMenu} color={currentColor} icon={<AiOutlineMenu />} />
      <div className="flex">
  
        <TooltipComponent content="Profile" position="BottomCenter">
          <div
            className="flex items-center gap-2 cursor-pointer p-1 hover:bg-light-gray rounded-lg"
            onClick={() => handleClick('userProfile')}
          >

                <button
                  type="button"
                  style={{ currentColor }}
                  className="relative text-xl rounded-full p-3 hover:bg-light-gray"
                >
                  <span
                    style={{ background: "#03C9D7" }}
                    className="absolute inline-flex rounded-full h-2 w-2 right-2 top-2"
                  />
                  <RxAvatar />
                </button>
            <p>
              <span className="text-gray-400 text-14">Hola,</span>{' '}
              <span className="text-gray-400 font-bold ml-1 text-14">
                {userInfo ? userInfo.nombre : ''}
              </span>
            </p>
            <MdKeyboardArrowDown className="text-gray-400 text-14" />
          </div>
        </TooltipComponent>
        <NavButton title="Cambiar Password" customFunc={() => handleClick('passwordusuario')} color={currentColor} icon={<MdOutlinePassword />} />
        <NavButton title="Salir" customFunc={() =>  {AuthServices.logout();  navigate('/login')}   } color={currentColor} icon={<MdLogout />} />
        {isClicked.passwordusuario && (<CambioPassword />)}
        {isClicked.userProfile && (<UserProfile />)}
      </div>
    </div>
  );
};

export default Navbar;